// @ts-nocheck
const logger = {};

logger.log = (...message) => {
  if (import.meta.env.MODE === "development") {}
};

logger.error = (...message) => {
  if (import.meta.env.MODE === "development") {
    console.error(...message);
  }
};

logger.warn = (...message) => {
  if (import.meta.env.MODE === "development") {
    console.warn(...message);
  }
};

export { logger };